import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

export const FORM_BLANK = 1;
export const FORM_PSYCHO_QUIZ = 2;
export const SIGNUP_FORM = 3;
export const REDEEM_FORM = 4;
export const FORM_QUIZ = 5;
export const FORM_SURVEY = 6;
export const FORM_LOTTERY_GAME = 7;
export const FORM_INVOICE = 8;
export const FORM_VOTE = 9;

const ratingIconConfig = {
    1: { value: 1, label: { hollow: StarBorderIcon, solid: StarIcon } },
    2: { value: 2, label: { hollow: FavoriteBorderIcon, solid: FavoriteIcon } },
    3: { value: 3, label: { hollow: CheckCircleOutlineIcon, solid: CheckCircleIcon } }
};

export const ratingIconSelectOptions = Object.entries(
    ratingIconConfig
).map(([, { value, label }]) => ({ value, label: label.solid }));

export function getIconByType(type) {
    const {
        label: { hollow, solid }
    } = ratingIconConfig[type] || ratingIconConfig[1];
    return [hollow, solid];
}

const config = {
    titleEdit: false,
    titleShowId: false,
    pageList: false,
    formBackground: false,
    formSetting: false,
    previewButton: false,
    publishButton: false,
    eventSubmit: false,
    encryptField: false,
    submitPostMessage: false,
    hiddenResultPage: false,
    enableRecaptCha: false,
    mergePromoSettingKeys: []
};

export function getTypeConfig(type) {
    switch (type) {
        // 一般表單
        case FORM_BLANK:
            return {
                ...config,
                titleEdit: true,
                titleShowId: true,
                pageList: true,
                encryptField: true,
                formBackground: true,
                formSetting: true,
                previewButton: true,
                publishButton: true,
                enableRecaptCha: true
            };
        // 報名表單 step3, 領獎表格
        case SIGNUP_FORM:
        case REDEEM_FORM:
            return {
                ...config,
                titleEdit: true,
                titleShowId: true,
                encryptField: true,
                formSetting: true,
                submitPostMessage: true,
                nextStep: 'adminStep3',
                enableRecaptCha: false,
                mergePromoSettingKeys: [
                    ['defaultContentBg', 'formContentBg'],
                    ['defaultTextColor', 'formContentTextColor'],
                    ['defaultDescColor', 'formContentDescColor'],
                    ['defaultAnwsColor', 'formAnswerTextColor'],
                    ['defaultBtnBgColor', 'formBtnBgColor'],
                    ['defaultBtnTextColor', 'formBtnTextColor'],
                    ['defaultOptionLabelColor', 'formOptionTextColor'],
                    ['defaultOptionColor', 'formOptionBgColor']
                ]
            };
        // 問卷
        case FORM_SURVEY:
            return {
                ...config,
                pageList: true,
                submitPostMessage: true,
                nextStep: 'promo',
                hiddenResultPage: true,
                formSetting: true,
                mergePromoSettingKeys: [
                    ['defaultContentBg', 'formContentBg'],
                    ['defaultTextColor', 'formContentTextColor'],
                    ['defaultDescColor', 'formContentDescColor'],
                    ['defaultAnwsColor', 'formAnswerTextColor'],
                    ['defaultBtnBgColor', 'formBtnBgColor'],
                    ['defaultBtnTextColor', 'formBtnTextColor'],
                    ['defaultOptionLabelColor', 'formOptionTextColor'],
                    ['defaultOptionColor', 'formOptionBgColor']
                ]
            };

        default:
            return {};
    }
}

export function toShowTagSetting(type) {
    switch (type) {
        // 報名表單 step3, 領獎表格
        case SIGNUP_FORM:
        case REDEEM_FORM:
            return true;
        default:
            return false;
    }
}

export const OPTION_TYPE = {
    EDIT: 1,
    DELETE: 2
};

/**
 * 選項類型
 * - NORMAL: 一般選項
 * - NORMAL_OTHER: 一般其他 + 單層下拉第一層其他 + 雙層下拉第二層其他
 * - TWO_LEVEL_OTHER: 雙層下拉第一層其他
 * - TWO_LEVEL_SECOND_OTHER: 雙層下拉第一層其他 附屬輸入框
 * - https://app.clickup.com/t/86ethhpvx
 */

export const OPTIONS_TYPE = {
    NORMAL: 1,
    NORMAL_OTHER: 2,
    TWO_LEVEL_OTHER: 3,
    TWO_LEVEL_SECOND_OTHER: 4
};

/**
 * 判斷選項是否達到限制
 * @param {Object} option - 選項
 * @param {number} option.currentValue - 選項的已選次數
 * @param {number} option.setting.submissionLimit - 選項的限制次數
 * @returns {number} 選項的剩餘次數
 */
export const getOptionLimitCount = option => {
    return option?.currentValue === undefined
        ? option?.setting?.submissionLimit ?? 0
        : option?.setting?.submissionLimit === undefined
        ? 0
        : option.setting?.submissionLimit - option?.currentValue;
};
